import { Routes } from '@angular/router';
import { MainComponent } from './shared/components/main/main.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { authenticationGuard } from './core/guards/auth.guard';
import { CallbackComponent } from './pages/callback/callback.component';

export const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: DashboardComponent },
            {
                path: 'deployment',
                loadChildren: () => import('./pages/deployment/deployment.module').then((m) => m.DeploymentModule)
            },
            {
                path: 'service',
                loadChildren: () => import('./pages/service/service.module').then((m) => m.ServiceModule)
            },
            {
                path: 'team',
                loadChildren: () => import('./pages/team/team.module').then((m) => m.TeamModule)
            },
            {
                path: 'user',
                loadChildren: () => import('./pages/user/user.module').then((m) => m.UserModule)
            },
            {
                path: 'kafka',
                loadChildren: () => import('./pages/kafka/kafka.module').then((m) => m.KafkaModule)
            },
            {
                path: 'tech-stack',
                loadChildren: () => import('./pages/tech-stack/tech-stack.module').then((m) => m.TechStackModule)
            }
        ],
        canActivate: [authenticationGuard()]
    },
    {
        path: 'access-denied',
        component: ForbiddenComponent
    },
    {
        path: 'callback',
        component: CallbackComponent
    }
];
